import { components, DropdownIndicatorProps } from 'react-select';
import styled from 'styled-components';

import { IconSelector } from '../../../common/icons/cdl/Selector';
import { theme } from '../../../common/ui/theme';

const StyledDropdownIndicator = styled.div<{ $isDisabled: boolean }>`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${(props) => (props.$isDisabled ? theme.colors.foreground.disabled : theme.colors.foreground.subtle)};
    transition: color 75ms ease-in-out;

    &:hover {
        color: ${(props) => (props.$isDisabled ? theme.colors.foreground.disabled : theme.colors.foreground.default)};
    }
`;

export const CustomDropdownIndicator = (props: DropdownIndicatorProps) => {
    return (
        <components.DropdownIndicator {...props}>
            <StyledDropdownIndicator $isDisabled={props.isDisabled}>
                <IconSelector width={16} height={16} />
            </StyledDropdownIndicator>
        </components.DropdownIndicator>
    );
};
